import * as yup from "yup";
export const schema = yup
  .object({
    name: yup.string().required(),
    key: yup.string().required(),
    icon: yup.string().required(),
    team: yup.array().of(yup.string().required()).min(1, 'Please select one team').required('team memeber are required'),
  });